export default __webpack_public_path__ + "static/media/arrowRight.0869a956.svg";